"use client";

import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Founder() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    label: "ESTABLISHED",
    value: "1977"
  }, {
    label: "PROJECTS",
    value: "500+"
  }, {
    label: "EXPERIENCE",
    value: "49 YRS"
  }];
  return <section data-section-id="1029" id="founderspotlight" className="bg-background text-foreground py-24 md:py-44 relative overflow-hidden border-t dark" style={{
    borderTopColor: "var(--primary)"
  }}>
      {}
      <div className="absolute top-0 left-0 right-0 h-px" style={{
      backgroundColor: "var(--primary)"
    }} aria-hidden="true" />

      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-center">
          {}
          <div ref={headingRef} className="lg:col-span-6 px-5 lg:pl-20 lg:pr-12 relative">
            {}
            <div className="absolute right-4 bottom-0 lg:right-12 pointer-events-none select-none font-default italic font-light leading-none" style={{
            fontSize: "clamp(8rem, 18vw, 16rem)",
            color: "var(--primary)",
            opacity: 0.05
          }} aria-hidden="true">
              AM
            </div>

            {}
            <div className={`font-default uppercase mb-12 lg:mb-16 transition-all duration-[800ms] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(0.6875rem, 0.8vw, 0.8125rem)",
            letterSpacing: "0.22em",
            color: "var(--muted-foreground)",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              FOUNDER / § 01 — THE MOSCARIELLO LEGACY
            </div>

            {}
            <h2 className="font-default font-light text-foreground relative transition-all duration-[800ms] delay-[80ms] opacity-100 translate-y-0 !italic" style={{
            fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
            letterSpacing: "-0.02em",
            lineHeight: "1.02",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>Building with&nbsp;<span className="!italic" data-ast-id="f:/src/pages/AboutUs/sections/Founder.tsx|sig:6ujwys" data-ast-start="2483" data-ast-end="2525">integrity</span>&nbsp;since 1977</h2>

            {}
            <div className={`relative my-10 lg:my-12 transition-all duration-[900ms] delay-[160ms] ${headingVisible ? "opacity-100" : "opacity-0"}`} style={{
            width: "200px"
          }}>
              <div className="h-px w-full bg-border" />
              <span className="absolute -right-0 top-1/2 -translate-y-1/2 w-1 h-1" style={{
              backgroundColor: "var(--secondary)"
            }} aria-hidden="true" />
            </div>

            {}
            <div className={`flex flex-wrap items-center gap-x-6 gap-y-3 mt-12 lg:mt-14 transition-all duration-[800ms] delay-[320ms] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              {stats.map((stat, i) => <div data-index={i} key={stat.label} className="flex items-center gap-x-6">
                  <div className="font-default uppercase whitespace-nowrap" style={{
                fontSize: "11px",
                letterSpacing: "0.22em",
                color: "var(--muted-foreground)"
              }}>
                    <span>{stat.label}</span>
                    <span className="mx-2" style={{
                  color: "var(--border)"
                }}>·</span>
                    <span style={{
                  color: "var(--foreground)"
                }}>{stat.value}</span>
                  </div>
                  {i < stats.length - 1 && <span className="hidden sm:inline-block h-px w-6" style={{
                backgroundColor: "var(--border)"
              }} aria-hidden="true" />}
                </div>)}
            </div>

            {}
            <div className={`mt-14 lg:mt-16 flex lg:justify-start transition-all duration-[800ms] delay-[400ms] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              <Link to="/TheMoscarielloLegacyPage" className="group inline-flex items-center gap-2 font-default uppercase text-sm transition-colors duration-200" style={{
              color: "var(--secondary)",
              letterSpacing: "0.08em",
              textDecorationLine: "underline",
              textUnderlineOffset: "6px",
              textDecorationThickness: "1px"
            }}>
                <span>Read our full story</span>
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.25} />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 px-5 lg:pr-20 lg:pl-12">
            {}
            

            {}
            <p className={`font-default italic font-normal max-w-[480px] transition-all duration-[800ms] delay-[240ms] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(1.125rem, 1.5vw, 1.375rem)",
            lineHeight: "1.6",
            color: "var(--muted-foreground)",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              Americo Moscariello founded Moscariello Construction Co, Inc with a simple vision: to provide unparalleled craftsmanship and property stewardship. For over two decades, we have transformed properties across Pennsylvania into lasting legacies.
            </p>
          </div>
        </div>
      </div>
    </section>;
}